import { fetchWithAuth } from '../AuthService';
import { DATA_SERVICE_BASE_URL } from '../ApiService';

/**
 * PaymentEventsMetricsApi
 * Analytics endpoints for payment webhook events
 */
export const PaymentEventsMetricsApi = {
  /**
   * Get webhook success/failure rates
   */
  getSuccessRate: async ({ from, to } = {}) => {
    const params = new URLSearchParams();
    if (from) params.set('from', typeof from === 'string' ? from : from.toISOString());
    if (to) params.set('to', typeof to === 'string' ? to : to.toISOString());
    
    return fetchWithAuth(
      `${DATA_SERVICE_BASE_URL}/api/payment-events/metrics/success-rate?${params}`,
      { method: 'GET' }
    );
  },

  /**
   * Get event type distribution
   */
  getEventTypeDistribution: async ({ from, to } = {}) => {
    const params = new URLSearchParams();
    if (from) params.set('from', typeof from === 'string' ? from : from.toISOString());
    if (to) params.set('to', typeof to === 'string' ? to : to.toISOString());
    
    return fetchWithAuth(
      `${DATA_SERVICE_BASE_URL}/api/payment-events/metrics/event-type-distribution?${params}`,
      { method: 'GET' }
    );
  },

  /**
   * Get daily volume time series
   */
  getVolumeSeries: async ({ from, to } = {}) => {
    const params = new URLSearchParams();
    if (from) params.set('from', typeof from === 'string' ? from : from.toISOString());
    if (to) params.set('to', typeof to === 'string' ? to : to.toISOString());
    
    return fetchWithAuth(
      `${DATA_SERVICE_BASE_URL}/api/payment-events/metrics/volume-series?${params}`,
      { method: 'GET' }
    );
  },

  /**
   * Get processing latency statistics
   */
  getProcessingLatency: async ({ from, to } = {}) => {
    const params = new URLSearchParams();
    if (from) params.set('from', typeof from === 'string' ? from : from.toISOString());
    if (to) params.set('to', typeof to === 'string' ? to : to.toISOString());
    
    return fetchWithAuth(
      `${DATA_SERVICE_BASE_URL}/api/payment-events/metrics/processing-latency?${params}`,
      { method: 'GET' }
    );
  },

  /**
   * Get provider distribution
   */
  getProviderDistribution: async ({ from, to } = {}) => {
    const params = new URLSearchParams();
    if (from) params.set('from', typeof from === 'string' ? from : from.toISOString());
    if (to) params.set('to', typeof to === 'string' ? to : to.toISOString());
    
    return fetchWithAuth(
      `${DATA_SERVICE_BASE_URL}/api/payment-events/metrics/provider-distribution?${params}`,
      { method: 'GET' }
    );
  },

  /**
   * Get comprehensive summary
   */
  getSummary: async ({ from, to } = {}) => {
    const params = new URLSearchParams();
    if (from) params.set('from', typeof from === 'string' ? from : from.toISOString());
    if (to) params.set('to', typeof to === 'string' ? to : to.toISOString());
    
    return fetchWithAuth(
      `${DATA_SERVICE_BASE_URL}/api/payment-events/metrics/summary?${params}`,
      { method: 'GET' }
    );
  },
};
